import {
  BaseCurrencyInput,
  Button,
  Hairline,
  Input,
  Label,
  Radio,
  Select,
} from "@components";
import styles from "@styles/containers/oraculo/oracle-drawer.module.scss";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useState } from "react";

dayjs.extend(customParseFormat);
require("dayjs/locale/br");

export default function DateForm({
  node,
  input_configs = {},
  onSave,
  onRemove,
}) {
  const [type, setType] = useState(node.range?.type || "eq");
  const [min, setMin] = useState(node.range?.min || null);
  const [max, setMax] = useState(node.range?.max || null);
  const [period, setPeriod] = useState(node.range?.period || "day");

  const getFreshNode = () => {
    return {
      ...node,
      range: { type, period, min, max },
    };
  };

  const changeType = (type) => {
    setType((oldType) => {
      if (oldType != type) {
        setPeriod("day");
        setMin(null);
        setMax(null);
      }
      return type;
    });
  };

  const validate = () => {
    switch (type) {
      case "in_last":
        return Number(min) > 0 && !!period;
      case "more_than":
        return Number(min) > 0 && !!period;
      case "eq":
      case "neq":
        return dayjs(
          min,
          input_configs?.format || "DD/MM/YYYY",
          "br",
          true
        ).isValid();
      case "range":
        const min_date = dayjs(
          min,
          input_configs?.format || "DD/MM/YYYY",
          "br",
          true
        );
        const max_date = dayjs(
          max,
          input_configs?.format || "DD/MM/YYYY",
          "br",
          true
        );
        return (
          min_date.isValid() &&
          max_date.isValid() &&
          min_date.isBefore(max_date)
        );
      default:
        return false;
    }
  };

  return (
    <>
      <div className={styles.scrollContainer}>
        <div className={styles.card}>
          <Label>Defina o uso desta variável:</Label>
          <Hairline solid className="mt-5 mb-20" />
          <Radio
            family="variableType"
            className="mb-10"
            value="eq"
            checked={type}
            onChange={() => changeType("eq")}
          >
            Igual a
          </Radio>
          <Radio
            family="variableType"
            className="mb-10"
            value="neq"
            checked={type}
            onChange={() => changeType("neq")}
          >
            Diferente de
          </Radio>
          <Radio
            family="variableType"
            className="mb-10"
            value="range"
            checked={type}
            onChange={() => changeType("range")}
          >
            No período
          </Radio>
          <Radio
            family="variableType"
            className="mb-10"
            value="in_last"
            checked={type}
            onChange={() => changeType("in_last")}
          >
            Nos últimos
          </Radio>
          <Radio
            family="variableType"
            className="mb-10"
            value="more_than"
            checked={type}
            onChange={() => changeType("more_than")}
          >
            A mais de
          </Radio>
        </div>

        <div className={styles.card}>
          <Label>Determine o valor de comparação:</Label>
          <Hairline solid className="mt-10 mb-20" />
          {["eq", "neq"].includes(type) && (
            <Input
              value={min}
              mask="99/99/9999"
              type="tel"
              placeholder="dd/mm/aaaa"
              onChange={(text) => setMin(text.target.value || 0)}
              className="mb-0"
              {...input_configs}
            />
          )}

          {["in_last", "more_than"].includes(type) && (
            <>
              <div className="d-flex mt-15">
                <BaseCurrencyInput
                  placeholder="Inserir valor"
                  className="w-50 mb-0 pt-5 pt-0"
                  precision={0}
                  prefix=""
                  type="tel"
                  value={min}
                  onChange={(v) => setMin(v)}
                />
                <Select
                  title="Selecione o tempo..."
                  className="w-50 ml-15 mb-0 pt-5"
                  value={period}
                  options={[
                    { label: "Dias", value: "day" },
                    { label: "Meses", value: "month" },
                    { label: "Anos", value: "year" },
                  ]}
                  onChange={(e) => setPeriod(e.target.value)}
                />
              </div>
            </>
          )}

          {type === "range" && (
            <>
              <div className="d-flex mt-15">
                <div className="d-flex flex-column w-50">
                  <Label mini>De</Label>
                  <Input
                    placeholder="dd/mm/aaaa"
                    mask="99/99/9999"
                    type="tel"
                    value={min}
                    onChange={(e) => setMin(e.target.value)}
                    className="mb-0"
                    {...input_configs}
                  />
                </div>
                <div className="d-flex flex-column w-50 ml-15">
                  <Label mini>Até</Label>
                  <Input
                    placeholder="dd/mm/aaaa"
                    mask="99/99/9999"
                    type="tel"
                    value={max}
                    onChange={(e) => setMax(e.target.value)}
                    className="mb-0"
                    {...input_configs}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <div className={styles.footer}>
        <Button
          className="w-100"
          onClick={() => onSave(getFreshNode())}
          disabled={!validate()}
          design="primary"
        >
          Aplicar
        </Button>
        <Button
          design="underline"
          className="mt-20 mb-10"
          onClick={() => onRemove(getFreshNode())}
        >
          Remover comparação
        </Button>
      </div>
    </>
  );
}
